module.exports = __webpack_public_path__ + "static/media/SoccerTouchArea.bcd395b1.png";